import React from 'react';
import { theme } from '../../config/theme';

const EmptyState = ({ 
  icon,
  title = 'No data found',
  description,
  action,
  className = '' 
}) => {
  const containerStyles = {
    textAlign: 'center',
    padding: theme.spacing['3xl'],
  };

  const iconStyles = {
    marginBottom: theme.spacing.lg,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: theme.colors.gray[400],
  };

  const titleStyles = {
    fontSize: theme.typography.fontSize.lg,
    fontWeight: theme.typography.fontWeight.semibold,
    color: theme.colors.text.primary,
    marginBottom: theme.spacing.sm,
  };

  const descriptionStyles = {
    fontSize: theme.typography.fontSize.sm,
    color: theme.colors.text.secondary,
    marginBottom: action ? theme.spacing.lg : 0,
  };

  return (
    <div className={className} style={containerStyles}>
      {icon && <div style={iconStyles}>{icon}</div>}
      <h3 style={titleStyles}>{title}</h3>
      {description && <p style={descriptionStyles}>{description}</p>}
      {action && <div>{action}</div>}
    </div>
  );
};

export default EmptyState;